export interface Campaign {
  id: string;
  title: string;
  description: string;
  imageUrl: string;
  reward: number;
  participants: number;
  maxParticipants: number;
  rating: number;
  reviewCount: number;
  status: 'active' | 'inactive' | 'completed';
  deadline: string;
  // 카테고리별 추가 필드
  area?: string;
  category?: string;
  store?: string;
}

// 지역별 캠페인 데이터
export const areaCampaigns: Campaign[] = [
  {
    id: 'area1',
    title: '서울 강남구 맛집 탐방',
    description: '강남구 신상 맛집들을 방문하고 솔직한 후기를 남겨주세요',
    imageUrl: 'https://placehold.co/400x250?text=강남맛집',
    area: '서울 강남구',
    reward: 500,
    participants: 23,
    maxParticipants: 30,
    rating: 4.8,
    reviewCount: 156,
    status: 'active',
    deadline: '2024-02-28'
  },
  {
    id: 'area2',
    title: '부산 해운대 카페 투어',
    description: '해운대 해변가 카페들을 체험하고 분위기를 평가해주세요',
    imageUrl: 'https://placehold.co/400x250?text=해운대카페',
    area: '부산 해운대구',
    reward: 400,
    participants: 18,
    maxParticipants: 25,
    rating: 4.6,
    reviewCount: 89,
    status: 'active',
    deadline: '2024-03-15'
  },
  {
    id: 'area3',
    title: '제주도 숙박 체험',
    description: '제주도 신상 펜션을 체험하고 여행 후기를 작성해주세요',
    imageUrl: 'https://placehold.co/400x250?text=제주펜션',
    area: '제주도',
    reward: 1000,
    participants: 8,
    maxParticipants: 15,
    rating: 4.9,
    reviewCount: 234,
    status: 'active',
    deadline: '2024-04-30'
  }
];

// 리포트 캠페인 데이터
export const reportCampaigns: Campaign[] = [
  {
    id: 'report1',
    title: '2024 뷰티 트렌드 리포트',
    description: '올해의 뷰티 트렌드를 분석하고 소비자 반응을 조사해주세요',
    imageUrl: 'https://placehold.co/400x250?text=뷰티트렌드',
    category: '뷰티',
    reward: 800,
    participants: 45,
    maxParticipants: 50,
    rating: 4.7,
    reviewCount: 312,
    status: 'active',
    deadline: '2024-02-20'
  },
  {
    id: 'report2',
    title: '스마트폰 사용 패턴 조사',
    description: '일상에서의 스마트폰 사용 패턴을 분석하고 개선점을 제안해주세요',
    imageUrl: 'https://placehold.co/400x250?text=스마트폰패턴',
    category: '전자제품',
    reward: 600,
    participants: 67,
    maxParticipants: 80,
    rating: 4.5,
    reviewCount: 445,
    status: 'active',
    deadline: '2024-03-10'
  },
  {
    id: 'report3',
    title: '홈카페 문화 조사',
    description: '홈카페 문화의 확산과 소비자 선호도를 조사해주세요',
    imageUrl: 'https://placehold.co/400x250?text=홈카페문화',
    category: '음식',
    reward: 700,
    participants: 34,
    maxParticipants: 40,
    rating: 4.8,
    reviewCount: 278,
    status: 'active',
    deadline: '2024-02-25'
  }
];

// 스토어리뷰 캠페인 데이터
export const storeReviewCampaigns: Campaign[] = [
  {
    id: 'store1',
    title: '올리브영 신상품 리뷰',
    description: '올리브영에서 출시된 신상품들을 체험하고 상세한 리뷰를 작성해주세요',
    imageUrl: 'https://placehold.co/400x250?text=올리브영',
    store: '올리브영',
    reward: 400,
    participants: 89,
    maxParticipants: 100,
    rating: 4.6,
    reviewCount: 567,
    status: 'active',
    deadline: '2024-02-15'
  },
  {
    id: 'store2',
    title: '스타벅스 신메뉴 체험',
    description: '스타벅스 신메뉴를 체험하고 맛과 서비스를 평가해주세요',
    imageUrl: 'https://placehold.co/400x250?text=스타벅스',
    store: '스타벅스',
    reward: 300,
    participants: 156,
    maxParticipants: 200,
    rating: 4.4,
    reviewCount: 892,
    status: 'active',
    deadline: '2024-02-10'
  },
  {
    id: 'store3',
    title: '유니클로 신상 의류 리뷰',
    description: '유니클로 신상 의류를 체험하고 착용감과 스타일을 평가해주세요',
    imageUrl: 'https://placehold.co/400x250?text=유니클로',
    store: '유니클로',
    reward: 500,
    participants: 78,
    maxParticipants: 90,
    rating: 4.7,
    reviewCount: 423,
    status: 'active',
    deadline: '2024-03-05'
  }
];

// 카테고리별 데이터 매핑
export const campaignData = {
  area: areaCampaigns,
  report: reportCampaigns,
  store: storeReviewCampaigns
};

// 카테고리 정보
export const categoryInfo = {
  area: {
    name: '지역별',
    icon: 'LocationOn',
    color: 'primary'
  },
  report: {
    name: '리포트',
    icon: 'Assignment',
    color: 'secondary'
  },
  store: {
    name: '스토어리뷰',
    icon: 'Store',
    color: 'success'
  }
}; 